import { render, staticRenderFns } from "./FloorSettingDialog copy.vue?vue&type=template&id=2604222e"
import script from "./FloorSettingDialog copy.vue?vue&type=script&lang=js"
export * from "./FloorSettingDialog copy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports